// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1-Pd0","header2":"Header_header2__10FGi","logo":"Header_logo__12atr","login":"Header_login__2mu7B"};